import { useLocaleContext } from "@app/scripts/react-providers/locales";
import { SortBy, SortByProps } from "@usereactify/search";
import React from "react";

import { FilterSortDrawerItem } from "@app/scripts/reactify/filters/FilterSortDrawerItem";

type RSSortByProps = React.ComponentProps<NonNullable<SortByProps["render"]>>;

export const FilterSortSort: React.FC = () => {
  const { facets } = useLocaleContext();

  return (
    <FilterSortDrawerItem id="rs__sort_by" title={facets?.sort_button || "Sort"} isActive={true}>
      <div className="rs__filter rs__sort">
        <SortBy render={Sort} />
      </div>
    </FilterSortDrawerItem>
  );
};

const Sort: React.FC<RSSortByProps> = (props) => {
  return (
    <div className="_field _field__select">
      <select
        className="select__select"
        value={props.sortOption?.handle}
        onChange={(event) => props.setSortOption(event.target.value)}
      >
        {props.sortOptions.map((sortOption) => (
          <option key={sortOption.handle} className="rs__sortby__option" value={sortOption.handle}>
            {sortOption.name}
          </option>
        ))}
      </select>
    </div>
  );
};
